import type { InputHTMLAttributes } from "react";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export function Input({ label, error, className = "", id, ...rest }: Props) {
  const inputId = id ?? rest.name ?? Math.random().toString(36).slice(2);
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label
          htmlFor={inputId}
          className="text-xs font-mono uppercase tracking-wider text-secondary"
        >
          {label}
        </label>
      )}
      <input
        {...rest}
        id={inputId}
        className={`
          bg-bg border border-border rounded-lg px-4 py-3
          text-primary placeholder:text-muted
          focus:outline-none focus:border-accent
          transition-colors
          ${error ? "border-red-500" : ""}
          ${className}
        `}
      />
      {error && (
        <span className="text-xs text-red-400 font-mono">{error}</span>
      )}
    </div>
  );
}
